import { ReportTemplateParameter } from "./report-template-parameter";

export class ReportTemplate {
    public id: number;
    public name: string;
    public reportTemplateParameters: ReportTemplateParameter[];
}